import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { makeStyles } from "@material-ui/core";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { MaterialTextFieldComponentModel } from "../../models/components.model";
import { useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { ShellConfig } from "../../models/common.model";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    direction: "rtl",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    height: "20px",
  },
}));

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

// controlId="formBasicEmail"
export default function MaterialTextFieldComponent(
  props: MaterialTextFieldComponentModel
) {
  const classes = useStyles();
  const handleChange = () => {};
  //   const jsonFile = useSelector((state: any) => state.style);
  // useEffect(() => {
  //   fetch(`${process.env.REACT_APP_SHELL_CONFIG}`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setJsonFile(data);
  //     });
  // }, []);
  const queryClient = useQueryClient();
  const jsonFile = queryClient.getQueryData<ShellConfig>("SHELLCONFIG");

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <div dir="rtl">
          {/* <Typography
        className="colorTitle textFont10 mbottom5"
        style={{ right: "2px", fontFamily: "iranSans" }}
      >
        {props.label}
      </Typography> */}
          <TextField
            className={
              props.error
                ? "shadowTextFieldError"
                : props.className
                ? props.className
                : "shadowTextField"
            }
            autoFocus={props.autoFocus}
            label={props.label}
            error={props.error}
            onChange={props.onChange}
            helperText={props.helperText}
            form-control
            margin="normal"
            variant="outlined"
            value={props.value}
            type={props.type}
            InputLabelProps={
              jsonFile?.muiColor === "success" ? {} : { style: { top: "0px" } }
            }
            multiline={props.multiline}
            rows={props.rows}
            name={props.name}
            id={props.id}
            color={
              jsonFile?.muiColor as
                | "error"
                | "primary"
                | "secondary"
                | "info"
                | "success"
                | "warning"
                | undefined
            }
            onKeyDown={props.onKeyDown}
            onBlur={props.onBlur}
            onFocus={props.onFocus}
            ref={props.ref}
            onMouseUp={props.onMouseUp}
            onSelect={props.onSelect}
            placeholder={props.placeHolder}
            required={props.required}
            inputProps={props.inputProps}
            disabled={props.disabled}
            sx={props.sx}
            InputProps={props.InputProps}
          />
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
}
